var _rect, _rect2, _circle, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 148,
    viewBox: "0 0 328 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 148,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 327,
    height: 147,
    stroke: "#E0E0E0",
    strokeDasharray: "2 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 74,
    r: 20,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 60C168.418 60 172 63.582 172 68C172 72.418 168.418 76 164 76C159.582 76 156 72.418 156 68C156 63.582 159.582 60 164 60ZM164 62C160.686 62 158 64.686 158 68C158 71.314 160.686 74 164 74C167.314 74 170 71.314 170 68C170 64.686 167.314 62 164 62Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164 64C165.105 64 166 64.895 166 66C166 67.105 165.105 68 164 68C162.895 68 162 67.105 162 66C162 64.895 162.895 64 164 64Z",
    fill: "#BDBDBD"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 100,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#9E9E9E"
  }, "\uC774\uBBF8\uC9C0 \uC5C6\uC74C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.b7af70d969b5057b9422c0ae4da5c3c3.svg";
export { ForwardRef as ReactComponent };